<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div>
            <label class="label-input">Content</label>
          </div>
          <div class="mb-10 wrap-title">
            <label class="">Title</label>
            <ckeditor :editor="editor" v-model="fields.titleContent" :config="editorConfig" />
          </div>
          <v-row>
            <v-col cols="12">
              <div>
                <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                  <label for="backgroundImageEnable" style="margin-bottom: 0" class="font-weight-bold"
                    >Background Image</label
                  >
                  <input type="checkbox" v-model="fields.backgroundImage.enable" id="backgroundImageEnable" />
                </div>
              </div>
              <UploadImage
                v-if="fields.backgroundImage.enable"
                @callback="handleUploadBackgroundImage"
                :image="{ imageSrc: fields.backgroundImage.image }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBackgroundImage"
              />
              <div class="d-flex align-center gap-3 mt-5">
                <input
                  type="color"
                  name="background-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.backgroundColor"
                  @change="handleChangeBackgroundColor"
                />
                <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mb-4 mt-5">
          <label class="label-input">Slides Per View</label>
          <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
          <v-row>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.mobile.slidesPerView"
                  label="Mobile"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.tablet.slidesPerView"
                  label="Tablet"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.desktop.slidesPerView"
                  label="Desktop"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showBtn" style="margin-bottom: 0" class="label-input">Items</label>
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.listItem" :key="item._key">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div>
                    <UploadImage
                      @callback="obj => handleUploadImageItem(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUploadItem(i)"
                    />
                  </div>
                  <div class="item-text mt-5">
                    <ckeditor :editor="editor" v-model="item.htmlText" :config="editorConfig" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input">Pagination Colors</label>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="pagination-active-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.paginationActiveColor"
                  @change="handleChangePaginationActiveColor"
                />
                <v-text-field v-model="fields.paginationActiveColor" label="Pagination Active Color" />
                <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="pagination-inactive-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.paginationInactiveColor"
                  @change="handleChangePaginationInactiveColor"
                />
                <v-text-field v-model="fields.paginationInactiveColor" label="Pagination Inactive Color" />
                <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'items-grid-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        backgroundColor: '',
        backgroundImage: {
          enable: false,
          image: '',
        },
        titleContent: '',
        listItem: [
          // {
          //   image: '',
          //   htmlText: '',
          // }
        ],
        paginationActiveColor: '#000000',
        paginationInactiveColor: '#cccccc',
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    this.ensureItemKeys();
  },
  methods: {
    generateItemKey() {
      return `ig_${Date.now().toString(36)}_${Math.random()
        .toString(36)
        .slice(2, 10)}`;
    },
    ensureItemKeys() {
      if (!Array.isArray(this.fields.listItem)) this.$set(this.fields, 'listItem', []);

      this.fields.listItem = this.fields.listItem.map(item => {
        if (item && item._key) return item;
        return { ...(item || {}), _key: this.generateItemKey() };
      });
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      this.ensureItemKeys();
      const updateHtml = updateHtmlFromData.sectionItemsGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields.backgroundColor = '#ffffff';
    },
    handleUploadBackgroundImage(obj) {
      this.fields.backgroundImage.image = obj.imageSrc;
      this.fields.backgroundImage.enable = true;
    },
    handleRemoveBackgroundImage() {
      this.fields.backgroundImage.image = '';
      this.fields.backgroundImage.enable = false;
    },

    handleUploadImageItem(obj, i) {
      this.fields.listItem[i].image = obj.imageSrc;
    },
    handleRemoveUploadItem(i) {
      this.fields.listItem[i].image = '';
    },
    handleAddItem() {
      this.fields.listItem.push({
        _key: this.generateItemKey(),
        image: '',
        htmlText: 'Item Name',
      });
    },
    handleRemoveItem(i) {
      this.fields.listItem.splice(i, 1);
    },
    handleChangePaginationActiveColor(event) {
      this.fields.paginationActiveColor = event.target.value;
    },
    handleChangePaginationInactiveColor(event) {
      this.fields.paginationInactiveColor = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields.paginationActiveColor = '#000000';
    },
    handleResetPaginationInactiveColor() {
      this.fields.paginationInactiveColor = '#cccccc';
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .wrap-title {
  .ck-editor__editable {
    min-height: 150px;
  }
}
::v-deep .item-text {
  .ck-editor__editable {
    min-height: 150px;
  }
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
